import React from "react";
import { connect } from "react-redux";
import i18next from "i18next";
import { EntityPage } from "../../_components/EntityPage/EntityPage";
import { userService } from "../../_services";
import { showGlobalConfirm } from "../../_services/snackbarService";
import { store } from "../../_helpers";
import { userActions } from "../../_actions";

class OrdersPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      entities: [],
    };
  }

  getConferenceId = () => {
    const { selectedConf } = this.props;
    return selectedConf && selectedConf.id ? selectedConf.id : 0;
  };

  getOrders = () => {
    const conferenceId = this.getConferenceId();
    if (!conferenceId) {
      this.setState({ entities: [] });
      return;
    }

    store.dispatch(userActions.loading(true));
    userService.getWrapper(
      "api/order?conference_id=" + conferenceId,
      (data) => {
        store.dispatch(userActions.loading(false));
        this.setState({ entities: Array.isArray(data.data) ? data.data : [] });
      },
      (error) => {
        store.dispatch(userActions.loading(false));
        if (error !== "") {
          this.setState({ entities: [] });
        }
      }
    );
  };

  costConvertor = (data) => {
    return data.cost === null || data.cost === undefined || data.cost === ""
      ? i18next.t("free")
      : data.cost;
  };

  payConvertor = (data) => {
    if (data.status === "paid") return null;
    return (
      <button
        type="button"
        className="btn btn--border"
        onClick={() => this.markPaid(data.id)}
      >
        {i18next.t("paid")}
      </button>
    );
  };

  markPaid = (id) => {
    showGlobalConfirm(i18next.t("mark_paid_confirm")).then((ok) => {
      if (!ok) return;

      store.dispatch(userActions.loading(true));
      userService.postWrapper(
        "api/order/" + id + "/success",
        {},
        () => {
          this.getOrders();
        },
        () => {
          store.dispatch(userActions.loading(false));
        }
      );
    });
  };

  render() {
    return (
      <EntityPage
        loader={this.getOrders}
        header={{
          title: i18next.t("orders"),
        }}
        list={{
          entities: this.state.entities,
          emptyText: i18next.t("orders_empty"),
          fields: [
            {
              name: "id",
              class: "tbl__item--text",
              head: "ID",
            },
            {
              name: "email",
              class: "tbl__item--text",
              head: i18next.t("email"),
            },
            {
              name: "ticket_type",
              class: "tbl__item--text",
              head: i18next.t("ticket_type"),
            },
            {
              name: "payment_method_label",
              class: "tbl__item--text",
              head: i18next.t("payment_method"),
            },
            {
              name: "cost",
              convertor: this.costConvertor,
              class: "tbl__item--text",
              head: i18next.t("price"),
            },
            {
              name: "status_label",
              class: "tbl__item--text",
              head: i18next.t("status"),
            },
            {
              name: "pay_action",
              convertor: this.payConvertor,
              class: "tbl__item--text",
              head: i18next.t("mark_paid"),
            },
          ],
          actions: () => [],
        }}
      />
    );
  }
}

function mapStateToProps(state) {
  const { user } = state;
  return {
    selectedConf: user ? user.selectedConf : null,
  };
}

const connectedOrdersPage = connect(mapStateToProps)(OrdersPage);
export { connectedOrdersPage as OrdersPage };
